import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c49c17b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "list-unstyled" }

import { ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { ErrorBag, handleFormError } from '@/core/common';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppTextarea from '@/core/components/form/AppTextarea.vue';
import AppFileInput from '@/core/components/form/AppFileInput.vue';
import FaIcon from '@/core/components/FaIcon.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import { TicketComment, useTicketComment } from '@/modules/ticket/TicketComment';
import { Ticket } from '@/modules/ticket/Ticket';

interface TicketViewCommentFormProps {
	ticket: Ticket;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketViewCommentForm',
  props: {
    ticket: {}
  },
  emits: [
	'saved',
],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();
const props = __props;
const emit = __emit;
const resource = useTicketComment(props.ticket.id);
const data = ref<Partial<TicketComment>>({
	message: '',
	private: false,
});
const isTypeSet = ref<boolean>(false);
const attachmentFiles = ref<File[]>([]);
const errors = ref<ErrorBag>({});

const setPrivate = (type: boolean|null) => {
	if (type === null) {
		isTypeSet.value = false;
	} else {
		isTypeSet.value = true;
		data.value.private = type;
	}
};

const attachmentSelected = (fileList: FileList) => {
	for (let i = 0; i < fileList.length; i++) {
		attachmentFiles.value.push(fileList[i]);
	}
};

const save = async () => {
	errors.value = {};

	try {
		const comment = await resource.post(Object.assign({}, data.value));

		const attachmentPromises = attachmentFiles.value.map((file: File) => {
			return resource.postAttachment(comment.id, comment.upload_session_key as string, file);
		});

		comment.attachments = await Promise.all(attachmentPromises);

		emit('saved', comment);
		data.value = {
			message: '',
			private: false,
		};
		attachmentFiles.value = [];
		setPrivate(null);
	} catch (e) {
		handleFormError(e as Error, errors);
	}
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(save, ["prevent"])
  }, [
    _createVNode(_Transition, { name: "expand" }, {
      default: _withCtx(() => [
        (!isTypeSet.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
              _createVNode(AppButton, {
                type: "button",
                class: "t-primary",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (setPrivate(false)), ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Skicka svar")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(AppButton, {
                type: "button",
                class: "t-primary",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (setPrivate(true)), ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Skapa privat anteckning")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "expand" }, {
      default: _withCtx(() => [
        (isTypeSet.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(AppFormGroup, {
                id: "ticket_comment_message",
                errors: errors.value.message,
                label: _unref($gettext)('Innehåll')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppTextarea, {
                    id: "ticket_comment_message",
                    modelValue: data.value.message,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.message) = $event)),
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"]),
              _createVNode(AppFormGroup, {
                id: "ticket_comment_attachments",
                label: _unref($gettext)('Bilagor')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppFileInput, {
                    id: "ticket_comment_attachments",
                    errors: errors.value.logotype_path,
                    accept: "image/*",
                    resetOnSelect: true,
                    multiple: true,
                    onFiles: attachmentSelected
                  }, null, 8, ["errors"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createElementVNode("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachmentFiles.value, (file) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: file.name
                  }, [
                    _createVNode(FaIcon, { icon: "paperclip" }),
                    _createTextVNode(" " + _toDisplayString(file.name), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("p", null, [
                (data.value.private)
                  ? (_openBlock(), _createBlock(AppButton, {
                      key: 0,
                      type: "submit",
                      class: "t-primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Skapa privat anteckning")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(AppButton, {
                      key: 1,
                      type: "submit",
                      class: "t-primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Skicka svar")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })),
                _createVNode(AppButton, {
                  type: "button",
                  class: "t-neutral",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (setPrivate(null)), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Avbryt")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 40, _hoisted_1))
}
}

})